const BookingGuestDayStatus = {
  Booked: 'Booked',
  StandBy: 'StandBy',
  Vacant: 'Vacant',
  Expected: 'Expected',
  FinalCheckout: 'finalcheckout'
};

export default BookingGuestDayStatus;
